// This function converts a string number like '12' to a number. It also
// handles string percent numbers like '5%'

export function stringToNumberConverter(input: string | null): number | null {
  if (input === null) {
    return null;
  }

  if (typeof input === 'string' && input.length > 0) {
    return Number(input.replace(/%/g, ''));
  }

  return null;
}
